import { render, staticRenderFns } from "./PackagesToTransfer.vue?vue&type=template&id=604997e5&"
import script from "./PackagesToTransfer.vue?vue&type=script&lang=ts&"
export * from "./PackagesToTransfer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports